var wgweb = (function () {
  'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _construct(Parent, args, Class) {
    if (isNativeReflectConstruct()) {
      _construct = Reflect.construct;
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }

    return _construct.apply(null, arguments);
  }

  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }

  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;

    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;

      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }

      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);

        _cache.set(Class, Wrapper);
      }

      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }

      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };

    return _wrapNativeSuper(Class);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  // 在 iOS 上，小程序的 javascript 代码是运行在 JavaScriptCore 中，是由 WKWebView 来渲染的，环境有 iOS8、iOS9、iOS10
  // 在 Android 上，小程序的 javascript 代码是通过 X5 JSCore来解析，是由 X5 基于 Mobile Chrome 37 内核来渲染的
  // 在 开发工具上， 小程序的 javascript 代码是运行在 nwjs 中，是由 Chrome Webview 来渲染的
  !function (global) {
    // ServiceJSBridge 对象兼容层
    if (typeof logxx === 'function' && logxx('jsbridge start'), !global.WGWebServiceJSBridge) {
      var hasDocument = global.hasOwnProperty('document'),
          isIOS = !1,
          callbacks = {},
          callbackIndex = 0,
          defaultEventHandlers = {},
          eventPrefix = 'custom_event_',
          handlers = {},
          IFRAME_PREFIX = 'hybridjsbrige_';

      if (hasDocument) {
        var userAgent = global.navigator.userAgent,
            isAndroid = userAgent.indexOf('Android') != -1;
        isIOS = !isAndroid;
      }

      var postMessage = function postMessage(event, paramsString, callbackId) {
        // postMessage
        if (isIOS) {
          global.webkit.messageHandlers.invokeHandler.postMessage({
            C: event,
            paramsString: paramsString,
            callbackId: callbackId
          });
        } else {
          var jsCoreHandleResult = WGWebJSCore.invokeHandler(event, paramsString, callbackId);

          if (typeof jsCoreHandleResult !== 'undefined' && typeof callbacks[callbackId] === 'function' && jsCoreHandleResult !== '') {
            try {
              jsCoreHandleResult = JSON.parse(jsCoreHandleResult);
            } catch (e) {
              jsCoreHandleResult = {};
            }

            callbacks[callbackId](jsCoreHandleResult), delete callbacks[callbackId];
          }
        }
      },
          retrieveIframe = function retrieveIframe(sid) {
        var iframeId = IFRAME_PREFIX + sid,
            iframe = document.querySelector('#' + iframeId);

        if (iframe) {
          document.documentElement.removeChild(iframe);
        }
      },
          invoke = function invoke(event, params, callback) {
        // postMessage
        var paramsString = JSON.stringify(params || {}),
            callbackId = ++callbackIndex; // reportLog(event,params,'','invoke');

        callbacks[callbackId] = callback;
        postMessage(event, paramsString, callbackId);
      },
          invokeCallbackHandler = function invokeCallbackHandler(callbackId, params) {
        var callback = callbacks[callbackId]; // reportLog('invokeCallbackHandler:'+callbackId,params,'','api2app2service_get');

        typeof callback === 'function' && callback(params), delete callbacks[callbackId];
        if (isIOS) retrieveIframe(callbackId);
      },
          publishCallbackHandler = function publishCallbackHandler(callbackId) {
        if (isIOS) retrieveIframe(callbackId);
      },
          on = function on(eventName, handler) {
        defaultEventHandlers[eventName] = handler;
      },
          subscribe = function subscribe(eventName, handler) {
        handlers[eventPrefix + eventName] = handler;
      },
          subscribeHandler = function subscribeHandler(eventName, data, webviewId, reportParams) {
        // 执行注册的回调
        var handler; // reportLog('subscribeHandler:'+eventName,data,[webviewId||''],'app2view_get');

        handler = eventName.indexOf(eventPrefix) != -1 ? handlers[eventName] : defaultEventHandlers[eventName];

        if (typeof handler === 'function') {
          handler(data, webviewId, reportParams);
        }
      };

      global.WGWebServiceJSBridge = {
        invoke: invoke,
        invokeCallbackHandler: invokeCallbackHandler,
        publishCallbackHandler: publishCallbackHandler,
        on: on,
        subscribe: subscribe,
        subscribeHandler: subscribeHandler
      };
    }
  }(window);

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  var base64 = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
       module.exports = factory(global)
          ;
  }((
      typeof self !== 'undefined' ? self
          : typeof window !== 'undefined' ? window
          : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal
  : commonjsGlobal
  ), function(global) {
      // existing version for noConflict()
      global = global || {};
      var _Base64 = global.Base64;
      var version = "2.5.1";
      // if node.js and NOT React Native, we use Buffer
      var buffer;
      if ( module.exports) {
          try {
              buffer = eval("require('buffer').Buffer");
          } catch (err) {
              buffer = undefined;
          }
      }
      // constants
      var b64chars
          = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
      var b64tab = function(bin) {
          var t = {};
          for (var i = 0, l = bin.length; i < l; i++) t[bin.charAt(i)] = i;
          return t;
      }(b64chars);
      var fromCharCode = String.fromCharCode;
      // encoder stuff
      var cb_utob = function(c) {
          if (c.length < 2) {
              var cc = c.charCodeAt(0);
              return cc < 0x80 ? c
                  : cc < 0x800 ? (fromCharCode(0xc0 | (cc >>> 6))
                                  + fromCharCode(0x80 | (cc & 0x3f)))
                  : (fromCharCode(0xe0 | ((cc >>> 12) & 0x0f))
                     + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                     + fromCharCode(0x80 | ( cc         & 0x3f)));
          } else {
              var cc = 0x10000
                  + (c.charCodeAt(0) - 0xD800) * 0x400
                  + (c.charCodeAt(1) - 0xDC00);
              return (fromCharCode(0xf0 | ((cc >>> 18) & 0x07))
                      + fromCharCode(0x80 | ((cc >>> 12) & 0x3f))
                      + fromCharCode(0x80 | ((cc >>>  6) & 0x3f))
                      + fromCharCode(0x80 | ( cc         & 0x3f)));
          }
      };
      var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
      var utob = function(u) {
          return u.replace(re_utob, cb_utob);
      };
      var cb_encode = function(ccc) {
          var padlen = [0, 2, 1][ccc.length % 3],
          ord = ccc.charCodeAt(0) << 16
              | ((ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8)
              | ((ccc.length > 2 ? ccc.charCodeAt(2) : 0)),
          chars = [
              b64chars.charAt( ord >>> 18),
              b64chars.charAt((ord >>> 12) & 63),
              padlen >= 2 ? '=' : b64chars.charAt((ord >>> 6) & 63),
              padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
          ];
          return chars.join('');
      };
      var btoa = global.btoa ? function(b) {
          return global.btoa(b);
      } : function(b) {
          return b.replace(/[\s\S]{1,3}/g, cb_encode);
      };
      var _encode = buffer ?
          buffer.from && Uint8Array && buffer.from !== Uint8Array.from
          ? function (u) {
              return (u.constructor === buffer.constructor ? u : buffer.from(u))
                  .toString('base64')
          }
          :  function (u) {
              return (u.constructor === buffer.constructor ? u : new  buffer(u))
                  .toString('base64')
          }
          : function (u) { return btoa(utob(u)) }
      ;
      var encode = function(u, urisafe) {
          return !urisafe
              ? _encode(String(u))
              : _encode(String(u)).replace(/[+\/]/g, function(m0) {
                  return m0 == '+' ? '-' : '_';
              }).replace(/=/g, '');
      };
      var encodeURI = function(u) { return encode(u, true) };
      // decoder stuff
      var re_btou = new RegExp([
          '[\xC0-\xDF][\x80-\xBF]',
          '[\xE0-\xEF][\x80-\xBF]{2}',
          '[\xF0-\xF7][\x80-\xBF]{3}'
      ].join('|'), 'g');
      var cb_btou = function(cccc) {
          switch(cccc.length) {
          case 4:
              var cp = ((0x07 & cccc.charCodeAt(0)) << 18)
                  |    ((0x3f & cccc.charCodeAt(1)) << 12)
                  |    ((0x3f & cccc.charCodeAt(2)) <<  6)
                  |     (0x3f & cccc.charCodeAt(3)),
              offset = cp - 0x10000;
              return (fromCharCode((offset  >>> 10) + 0xD800)
                      + fromCharCode((offset & 0x3FF) + 0xDC00));
          case 3:
              return fromCharCode(
                  ((0x0f & cccc.charCodeAt(0)) << 12)
                      | ((0x3f & cccc.charCodeAt(1)) << 6)
                      |  (0x3f & cccc.charCodeAt(2))
              );
          default:
              return  fromCharCode(
                  ((0x1f & cccc.charCodeAt(0)) << 6)
                      |  (0x3f & cccc.charCodeAt(1))
              );
          }
      };
      var btou = function(b) {
          return b.replace(re_btou, cb_btou);
      };
      var cb_decode = function(cccc) {
          var len = cccc.length,
          padlen = len % 4,
          n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0)
              | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0)
              | (len > 2 ? b64tab[cccc.charAt(2)] <<  6 : 0)
              | (len > 3 ? b64tab[cccc.charAt(3)]       : 0),
          chars = [
              fromCharCode( n >>> 16),
              fromCharCode((n >>>  8) & 0xff),
              fromCharCode( n         & 0xff)
          ];
          chars.length -= [0, 0, 2, 1][padlen];
          return chars.join('');
      };
      var _atob = global.atob ? function(a) {
          return global.atob(a);
      } : function(a){
          return a.replace(/\S{1,4}/g, cb_decode);
      };
      var atob = function(a) {
          return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
      };
      var _decode = buffer ?
          buffer.from && Uint8Array && buffer.from !== Uint8Array.from
          ? function(a) {
              return (a.constructor === buffer.constructor
                      ? a : buffer.from(a, 'base64')).toString();
          }
          : function(a) {
              return (a.constructor === buffer.constructor
                      ? a : new buffer(a, 'base64')).toString();
          }
          : function(a) { return btou(_atob(a)) };
      var decode = function(a){
          return _decode(
              String(a).replace(/[-_]/g, function(m0) { return m0 == '-' ? '+' : '/' })
                  .replace(/[^A-Za-z0-9\+\/]/g, '')
          );
      };
      var noConflict = function() {
          var Base64 = global.Base64;
          global.Base64 = _Base64;
          return Base64;
      };
      // export Base64
      global.Base64 = {
          VERSION: version,
          atob: atob,
          btoa: btoa,
          fromBase64: decode,
          toBase64: encode,
          utob: utob,
          encode: encode,
          encodeURI: encodeURI,
          btou: btou,
          decode: decode,
          noConflict: noConflict,
          __buffer__: buffer
      };
      // if ES5 is available, make Base64.extendString() available
      if (typeof Object.defineProperty === 'function') {
          var noEnum = function(v){
              return {value:v,enumerable:false,writable:true,configurable:true};
          };
          global.Base64.extendString = function () {
              Object.defineProperty(
                  String.prototype, 'fromBase64', noEnum(function () {
                      return decode(this)
                  }));
              Object.defineProperty(
                  String.prototype, 'toBase64', noEnum(function (urisafe) {
                      return encode(this, urisafe)
                  }));
              Object.defineProperty(
                  String.prototype, 'toBase64URI', noEnum(function () {
                      return encode(this, true)
                  }));
          };
      }
      //
      // export Base64 to the namespace
      //
      if (global['Meteor']) { // Meteor.js
          Base64 = global.Base64;
      }
      // module.exports and AMD are mutually exclusive.
      // module.exports has precedence.
      if ( module.exports) {
          module.exports.Base64 = global.Base64;
      }
      // that's it!
      return {Base64: global.Base64}
  }));
  });
  var base64_1 = base64.Base64;

  var AppServiceSdkKnownError =
  /*#__PURE__*/
  function (_Error) {
    _inherits(AppServiceSdkKnownError, _Error);

    function AppServiceSdkKnownError(e) {
      var _this;

      _classCallCheck(this, AppServiceSdkKnownError);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(AppServiceSdkKnownError).call(this, "APP-SERVICE-SDK:" + e));
      _this.type = "AppServiceSdkKnownError";
      return _this;
    }

    return AppServiceSdkKnownError;
  }(_wrapNativeSuper(Error));

  function surroundByTryCatchFactory(func, funcName) {
    //返回函数e
    return function () {
      try {
        return func.apply(func, arguments);
      } catch (e) {
        if ("[object Error]" === Object.prototype.toString.apply(e)) {
          if ("AppServiceSdkKnownError" == e.type) throw e;
          /*Reporter.errorReport({
              key: "appServiceSDKScriptError",
              error: e,
              extend: funcName
          })*/
        }
      }
    };
  }

  function surroundThirdByTryCatch(fn, ext) {
    return function () {
      var res;

      try {
        var startTime = Date.now();
        res = fn.apply(fn, arguments);
        var doTime = Date.now() - startTime;
        doTime > 1e3;
        /*&&
        utils.slowReport({
        key: 'apiCallback',
        cost: doTime,
        extend: ext
        })*/
      } catch (e) {
        console.log(e);
        /*utils.thirdErrorReport({
          error: e,
          extend: ext
        })*/
      }

      return res;
    };
  }

  function getDataType(data) {
    //get data type
    return Object.prototype.toString.call(data).split(" ")[1].split("]")[0];
  }

  function isObject(e) {
    return "Object" === getDataType(e);
  }

  function paramCheck$1(params, paramTpl) {
    //比较e\t
    var result,
        name = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "parameter",
        tplTpye = getDataType(paramTpl),
        pType = getDataType(params);
    if (pType != tplTpye) return name + " should be " + tplTpye + " instead of " + pType + ";";

    switch (result = "", tplTpye) {
      case "Object":
        for (var i in paramTpl) {
          result += paramCheck$1(params[i], paramTpl[i], name + "." + i);
        }

        break;

      case "Array":
        if (params.length < paramTpl.length) return name + " should have at least " + paramTpl.length + " item;";

        for (var a = 0; a < paramTpl.length; ++a) {
          result += paramCheck$1(params[a], paramTpl[a], name + "[" + a + "]");
        }

    }

    return result;
  }

  var utils = {
    surroundByTryCatchFactory: surroundByTryCatchFactory,
    AppServiceSdkKnownError: AppServiceSdkKnownError,
    surroundThirdByTryCatch: surroundThirdByTryCatch,
    getDataType: getDataType,
    isObject: isObject,
    paramCheck: paramCheck$1
  };

  function invoke() {
    WGWebServiceJSBridge.invoke.apply(WGWebServiceJSBridge, arguments);
  }

  function on() {
    WGWebServiceJSBridge.on.apply(WGWebServiceJSBridge, arguments);
  }

  function publish() {
    var args = Array.prototype.slice.call(arguments);
    args[1] = {
      data: args[1],
      options: {
        timestamp: Date.now()
      }
    };
    WGWebServiceJSBridge.publish.apply(WGWebServiceJSBridge, args);
  }

  function subscribe() {
    var args = Array.prototype.slice.call(arguments),
        callback = args[1];

    args[1] = function (params) {
      var data = params.data;

      if ("function" == typeof callback) {
        callback(data);
      }
    };

    WGWebServiceJSBridge.subscribe.apply(WGWebServiceJSBridge, args);
  }

  function invokeMethod(apiName) {
    var options = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        innerFns = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
        params = {};

    for (var i in options) {
      "function" == typeof options[i] && (params[i] = utils.surroundThirdByTryCatch(options[i], "at api " + apiName + " " + i + " callback function"), delete options[i]);
    }

    var sysEventFns = {};

    for (var s in innerFns) {
      "function" == typeof innerFns[s] && (sysEventFns[s] = utils.surroundByTryCatchFactory(innerFns[s], "at api " + apiName + " " + s + " callback function"));
    }

    invoke(apiName, options, function (res) {
      if ('string' == typeof res) {
        res = base64_1.decode(res);
        res = JSON.parse(res);
      }

      res.errMsg = res.errMsg || apiName + ":ok";
      var isOk = 0 === res.errMsg.indexOf(apiName + ":ok"),
          isCancel = 0 === res.errMsg.indexOf(apiName + ":cancel"),
          isFail = 0 === res.errMsg.indexOf(apiName + ":fail");

      if ("function" == typeof sysEventFns.beforeAll && sysEventFns.beforeAll(res), isOk) {
        "function" == typeof sysEventFns.beforeSuccess && sysEventFns.beforeSuccess(res), "function" == typeof params.success && params.success(res), "function" == typeof sysEventFns.afterSuccess && sysEventFns.afterSuccess(res);
      } else if (isCancel) {
        res.errMsg = res.errMsg.replace(apiName + ":cancel", apiName + ":fail cancel"), "function" == typeof params.fail && params.fail(res), "function" == typeof sysEventFns.beforeCancel && sysEventFns.beforeCancel(res), "function" == typeof params.cancel && params.cancel(res), "function" == typeof sysEventFns.afterCancel && sysEventFns.afterCancel(res);
      } else if (isFail) {
        "function" == typeof sysEventFns.beforeFail && sysEventFns.beforeFail(res), "function" == typeof params.fail && params.fail(res);
        var rt = !0;
        "function" == typeof sysEventFns.afterFail && (rt = sysEventFns.afterFail(res)), rt !== !1 && 1;
        /*Reporter.reportIDKey({
        key: apiName + "_fail"
        })*/
      }

      "function" == typeof params.complete && params.complete(res), "function" == typeof sysEventFns.afterAll && sysEventFns.afterAll(res);
    });
  }

  function noop() {}

  function onMethod(apiName, callback) {
    //onMethod
    on(apiName, utils.surroundByTryCatchFactory(callback, "at api " + apiName + " callback function"));
  }

  function beforeInvoke(apiName, params, paramTpl) {
    var res = utils.paramCheck(params, paramTpl);
    return !res || (beforeInvokeFail(apiName, params, "parameter error: " + res), !1);
  }

  function beforeInvokeFail(apiName) {
    var params = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        errMsg = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
        err = apiName + ":fail " + errMsg;
    console.error(err);
    var fail = utils.surroundThirdByTryCatch(params.fail || noop, "at api " + apiName + " fail callback function"),
        complete = utils.surroundThirdByTryCatch(params.complete || noop, "at api " + apiName + " complete callback function");
    fail({
      errMsg: err
    });
    complete({
      errMsg: err
    });
  }

  var bridge = {
    invoke: invoke,
    on: on,
    publish: publish,
    subscribe: subscribe,
    invokeMethod: invokeMethod,
    onMethod: onMethod,
    noop: noop,
    beforeInvoke: beforeInvoke,
    beforeInvokeFail: beforeInvokeFail
  };

  var WX = {};
  var apiObj = {
    invoke: bridge.invoke,
    on: bridge.on,
    uploadFile: function uploadFile(params) {
      if (paramCheck('uploadFile', params, {
        url: '',
        filePath: '',
        name: ''
      })) {
        _typeof(params.header) !== 'object' && typeof params.header !== 'undefined' && (console.warn('uploadFile: header must be an object'), delete params.header), _typeof(params.formData) !== 'object' && typeof params.formData !== 'undefined' && (console.warn('uploadFile: formData must be an object'), delete params.formData);
        var header = {},
            formData = {};
        params.header && (header = utils.convertObjectValueToString(params.header));
        params.formData && (formData = utils.convertObjectValueToString(params.formData));
        bridge.invokeMethod('uploadFile', utils.assign({}, params, {
          header: header,
          formData: formData
        }), {
          beforeSuccess: function beforeSuccess(res) {
            res.statusCode = parseInt(res.statusCode);
          }
        });
      }
    },
    startRecord: function startRecord(params) {
      bridge.invokeMethod('startRecord', params);
    },
    stopRecord: function stopRecord(params) {
      bridge.invokeMethod('stopRecord', params);
    },
    startDownload: function startDownload(params) {
      bridge.invokeMethod('startDownload', params);
    },
    updateDownload: function updateDownload(params) {
      bridge.invokeMethod('updateDownload', params);
    },
    pauseDownload: function pauseDownload(params) {
      bridge.invokeMethod('pauseDownload', params);
    },
    getDownloadState: function getDownloadState(params) {
      bridge.invokeMethod('getDownloadState', params);
    },
    openApp: function openApp(params) {
      bridge.invokeMethod('openApp', params);
    },
    installApp: function installApp(params) {
      bridge.invokeMethod('installApp', params);
    },
    checkAppIsInstall: function checkAppIsInstall(params) {
      bridge.invokeMethod('checkAppIsInstall', params);
    },
    notifySetting: function notifySetting(params) {
      bridge.invokeMethod('notifySetting', params);
    },
    getPlatAuthInfo: function getPlatAuthInfo(params) {
      bridge.invokeMethod('getPlatAuthInfo', params);
    },
    getThirdAuthInfo: function getThirdAuthInfo(params) {
      bridge.invokeMethod('getThirdAuthInfo', params);
    },
    getGameBindInfo: function getGameBindInfo(params) {
      bridge.invokeMethod('getGameBindInfo', params);
    },
    getNetworkType : function getNetworkType(params) {
        bridge.invokeMethod('getNetworkType', params)
    },
    onNetworkStatusChange : function onNetworkStatusChange(params) {
         bridge.invokeMethod('onNetworkStatusChange', params)
    }
  };

  function addGetterForWX(apiKey) {
    WX.__defineGetter__(apiKey, function () {
      return utils.surroundByTryCatchFactory(apiObj[apiKey], 'wgweb.' + apiKey);
    });
  }

  for (var key in apiObj) {
    addGetterForWX(key);
  }

  function bindApi(item) {
    if (!item.name) {
      return;
    }

    WX[item.name] = function (params) {
      params = params || {};

      if (item.params && !paramCheck(item.name, params, item.params)) {
        return;
      }

      if (item.fn) {
        item.fn.call(apiObj, params);
      } else {
        bridge.invokeMethod(item.name, params, item.option);
      }
    };
  }

  WX.loadExtApi = function (conf) {
    if (conf) {
      var type = utils.getDataType(conf);

      if (type == 'Array') {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = conf[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;
            bindApi(item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if (type == 'Object') {
        bindApi(conf);
      }
    }
  };

  window.WGWebExtApiConf && WX.loadExtApi(window.WGWebExtApiConf);
  window.wgweb = WX;

  return WX;

}());

module.exports = {
  wgweb
}
